module.exports = __webpack_public_path__ + "img/clickable-image-stimuli-symbol.ebf67c29.svg";